// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/admin/app.scss
// module id = 20
// module chunks = 0